export default () => {
  if (!customElements.get('localization-form')) {
    customElements.define(
      'localization-form',
      class LocalizationForm extends HTMLElement {
        constructor() {
          super();
          this.elements = {
            input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
            button: this.querySelector('button'),
            panel: this.querySelector('ul'),
          };
          // We remove the previous functions named openSelector and closeSelector because of a Safari's bug.
          // Safari doesn't support focus on buttons element in the same way as other browsers do.
          // The drawback of this is that introduce an extra event listener on the document.
          // More details here https://bugs.webkit.org/show_bug.cgi?id=22261#c68
          document.addEventListener('click', this.toggleSelector.bind(this));
          this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

          this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        }

        hidePanel() {
          this.elements.button.setAttribute('aria-expanded', 'false');
          this.elements.panel.setAttribute('hidden', true);
        }

        onContainerKeyUp(event) {
          if (event.code.toUpperCase() !== 'ESCAPE') return;

          this.hidePanel();
        }

        onItemClick(event) {
          event.preventDefault();
          const form = this.querySelector('form');
          this.elements.input.value = event.currentTarget.dataset.value;
          if (form) {
            const params = new URLSearchParams(window.location.search);

            // Remove price filters since they are country-specific
            const filtersParam = params.get('filters');
            if (filtersParam) {
              try {
                const parsed = JSON.parse(filtersParam);
                if (Array.isArray(parsed)) {
                  const nonPrice = parsed.filter(([name]) => !name?.startsWith('price'));
                  if (nonPrice.length) {
                    params.set('filters', JSON.stringify(nonPrice));
                  } else {
                    params.delete('filters');
                  }
                }
              } catch {
                params.delete('filters');
              }
            }

            const qs = params.toString();
            const returnTo = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;
            let returnInput = form.querySelector('input[name="return_to"]');
            if (!returnInput) {
              returnInput = document.createElement('input');
              returnInput.type = 'hidden';
              returnInput.name = 'return_to';
              form.appendChild(returnInput);
            }
            returnInput.value = returnTo;

            form.submit();
          }
        }

        // We remove the previous functions named openSelector and closeSelector because of a Safari's bug.
        // Safari doesn't support focus on buttons element in the same way as other browsers do.
        // The drawback of this is that introduce an extra event listener on the document.
        // More details here https://bugs.webkit.org/show_bug.cgi?id=22261#c68
        toggleSelector(event) {
          if (event.target && event.target.closest('.Footer__countrySelector-disclosure__button')) {
            this.elements.button.setAttribute(
              'aria-expanded',
              (this.elements.button.getAttribute('aria-expanded') === 'false').toString(),
            );
            return this.elements.panel.toggleAttribute('hidden');
          }
          return this.hidePanel();
        }
      },
    );
  }
};
